import mascot from "/boot-mascot.webp";

const BootLoader = () => (
  <div className="flex items-center justify-center min-h-dvh bg-background">
    <div className="relative w-[140px] h-[140px] flex items-center justify-center">
      <div
        className="absolute inset-0 rounded-full border-[3px] border-transparent animate-spin"
        style={{
          borderTopColor: "hsl(var(--primary))",
          borderRightColor: "hsl(var(--primary) / 0.5)",
          animationDuration: "1.1s",
        }}
        aria-hidden="true"
      />
      <img
        src={mascot}
        alt="KelasAI"
        className="w-24 h-24 object-contain"
        style={{ animation: "boot-pulse 1.8s ease-in-out infinite" }}
      />
      <style>{`@keyframes boot-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.06)}}`}</style>
    </div>
  </div>
);

export default BootLoader;